<template>
  <Form
    v-if="Object.keys(props.fields).length"
    ref="form"
    v-slot="{ meta, errors, resetForm, submitForm }"
    class="row formStyleSecond"
    autocomplete
    :validate-on-change="true"
    :validate-on-input="true"
    @submit="(e) => {
      submitFormRef.click()
    }"
  >
    <button
      ref="submitFormRef"
      type="hidden"
      class="hidden"
      @click="() => {
        emit('isValid', meta.valid && !hasCustomErrors)
        
        if (meta.valid && !hasCustomErrors) {
          emit('submitForm')
        }
      }"
    >
      {{ $t('submit') }}
    </button>

    <div
      class="js-resetForm"
      @click="resetForm()"
    ></div>

    <div
      ref="startValidateForm"
      class="js-startValidateForm"
      @click="() => {
        emit('isValid', meta.valid && !hasCustomErrors)
        emit('invalidData', !meta.valid || hasCustomErrors)

        submitForm()
      }"
    >
    </div>

    <template
      v-for="{
        name,
        value,
        secondName,
        fileFieldName,
        label,
        subLabel,
        altLabel,
        tooltip,
        helpersData,
        isGroup,
        disclaimer,
        disclaimerWithTooltip,
        warning,
        error,
        placeholder,
        type,
        variant,
        maska,
        fieldType,
        parentClasses,
        elementClasses,
        min,
        max,
        fields: groupFields,
        additionalFields,
        options,
        availableProjects,
        disabledSelectOptions,
        disabled = false,
        disableSelectOption = false,
        enabled = true,
        hidden = false,
        pending = false,
        callback = () => {},
        invalid = false,
        onChange = () => {},
        onInput = () => {},
        invalidField = () => {},
        isField = true,
        hiddenCheckbox = false,
        externalReviews = false,
        accept,
        linkTo,
        linkType,
        additionalOptions = {},
        ...attrs
      }, i in props.fields"
    >
      <div
        v-if="enabled && fieldType === 'helpers'"
        :key="name"
        class="input-field col active"
        :class="[ parentClasses ? parentClasses : 's12 m12 m12' ]"
      >
        <button
          type="button"
          :class="[ elementClasses ? elementClasses : '' ]"
          variant="link"
          class="flex items-center space-x-2 justify-center transition duration-200 ease-in-out hover:opacity-85"
          @click="drawerOptions.helpers = {
            typeId: 'helpers',
            componentId: 'FormsGroupHelpers',
            header: helpersData.header,
            items: helpersData.items,
            returnData: () => {}
          }"
        >
          <span
            :class="additionalOptions.labelIcon ? additionalOptions.labelIcon : 'icon icon-circle-info-sparkle'"
            class="text-[24px]"
          ></span>

          <span
            class="text-neutral-700 font-inter text-base font-normal leading-6 underline decoration-1 decoration-[#3F3F3F] underline-offset-4 transition duration-200 ease-in-out"
          >{{ label ? label : $t('helpers.seeExamples') }}</span>
        </button>
      </div>

      <div
        v-if="enabled && fieldType === 'heading'"
        :key="name"
        class="input-field col active"
        :class="[ parentClasses ? parentClasses : 's12 m12 m12' ]"
      >
        <div
          :class="[ elementClasses ? elementClasses : 'h3' ]"
        >
          <span
            v-html="label"
          ></span>
          
          <span
            v-if="subLabel"
            class="subLabel"
          > {{ subLabel }}</span>

          <HelpersTooltipHelpers
            v-if="tooltip || helpersData"
            :data="{
              parentClasses: 'px-2 ml-0 inline-block',
              tooltip,
              helpersData
            }"
          />
        </div>
      </div>

      <div
        v-if="enabled && fieldType === 'image'"
        :key="name"
        class="input-field col active"
        :class="[ parentClasses ? parentClasses : 's12 m12 m12' ]"
      >
        <Image
          :preview="additionalOptions?.enableFullscreen !== false"
          alt=""
          class="w-full"
          :class="[ elementClasses ? elementClasses : '' ]"
          :rotate-left-button="false"
        >
          <template #previewicon>
            <i class="previewIcon"></i>
          </template>

          <template #image>
            <nuxt-picture
              preload
              loading="lazy"
              :img-attrs="{ class: 'w-full', alt: '' }"
              :src="value?.original?.length > 2 ? value?.original : '/img/na.png'"
            />
          </template>

          <template #preview="slotProps">
            <img
              :src="value?.original?.length > 2 ? value?.original : '/img/na.png'"
              alt=""
              :style="slotProps.style"
              @click="slotProps.onClick"
            />
          </template>
        </Image>
      </div>

      <div
        v-if="enabled && fieldType !== 'heading' && fieldType !== 'image' && fieldType !== 'helpers'"
        v-show="!hidden"
        :key="name"
        :set="emit('isValid', meta.valid)"
        class="input-field col active "
        :class="[
          parentClasses ? parentClasses : 's12 m12 m12',
          label ? 'mb-4 md:!mb-6' : '',
          type === 'checkbox' || type === 'radio' ? 'fixedLabel' : 'staticLabel',
          fieldType === 'attachFile' ? 'fixedLabel' : '',
          {'required': (attrs.rules && (Object.keys(attrs.rules.exclusiveTests).includes('required') || !attrs.rules.spec.optional) && type !== 'checkbox' && fieldType !== 'button') && additionalOptions.hideRequired !== true},
          {'invalid': errors[name] || invalid || customErrors[name]},
          {'isQuantity': fieldType === 'quantity'},
          
        ]"
      >
        <div
          class="relative"
          :class="[
            {'pl-14': additionalOptions?.stepper}
          ]"
        >
          <div
            v-if="additionalOptions?.stepper?.label"
            class="absolute left-0 bg-surface-300 h-8 w-8 rounded-full flex items-center justify-center text-[1rem] font-light"
            :class="[
              {'-top-8': label}
            ]"
            v-html="additionalOptions?.stepper?.label"
          ></div>

          <div
            v-if="additionalOptions?.stepper?.divider"
            class="absolute w-[1px] h-[calc(100%+2rem)] left-4 bg-surface-300"
          ></div>

          <Field
            v-if="isField"
            v-slot="{ field, errorMessage }"
            v-bind="attrs"
            v-model="formData[name]"
            :name="name"
          >
            <template v-if="fieldType === 'input'">
              <InputMask
                v-if="maska"
                v-bind="field"
                :id="`${uniqId}_${i}`"
                :mask="maska"
                :slot-char="typeof additionalOptions.slotChar !== 'undefined' ? additionalOptions.slotChar : '_'"
                :auto-clear="false"
                :type="showPassword[name] ? 'text' : type"
                :disabled="disabled"
                :autocomplete="name"
                :placeholder="placeholder"
                :min="min"
                :max="max"
                :class="[errorMessage ? 'invalid' : 'valid', elementClasses ]"
                :invalid="errorMessage ? true : false"
                :size="props.options?.size"
                @blur="onChange(formData[name])"
                @input="onInput(formData[name])"
              />

              <InputText
                v-else
                v-bind="field"
                :id="`${uniqId}_${i}`"
                :disabled="disabled"
                :autocomplete="name"
                :type="showPassword[name] ? 'text' : type"
                :placeholder="placeholder"
                :min="min"
                :max="max"
                :class="[errorMessage ? 'invalid' : 'valid', elementClasses ]"
                :invalid="errorMessage ? true : false"
                :size="props.options?.size"
                @blur="onChange(formData[name])"
                @input="onInput(formData[name])"
              />
            </template>

            <template v-if="fieldType === 'textarea'">
              <Textarea
                v-bind="field"
                :id="`${uniqId}_${i}`"
                auto-resize
                :rows="additionalOptions?.rows ? additionalOptions.rows : 5"
                :disabled="disabled"
                :autocomplete="name"
                :placeholder="placeholder"
                :invalid="errorMessage ? true : false"
                :class="[errorMessage ? 'invalid' : 'valid', elementClasses ]"
                @blur="onChange(formData[name])"
                @input="onInput(formData[name])"
              />
            </template>

            <FormsGeneratorDefaultEditor
              v-if="fieldType === 'editor'"
              :data="{
                id: `${uniqId}_${i}`,
                field,
                formData,
                name,
                maska,
                disabled,
                placeholder,
                min,
                max,
                errorMessage,
                onChange,
                additionalOptions
              }"
              @return-data-blur="(n) => {
                onChange(formData[name])
                formData[name] = n
              }"
              @return-data-input="(n) => {
                onInput(formData[name])
                formData[name] = n
              }"
              @return-data="(n) => {
                onChange(formData[name])
                formData[name] = n
              }"
            />

            <FormsGeneratorDateTimePicker
              v-if="fieldType === 'date'"
              :data="{
                id: `${uniqId}_${i}`,
                field,
                formData,
                name,
                maska,
                disabled,
                placeholder,
                min,
                max,
                errorMessage,
                onChange,
                additionalOptions
              }"
              @return-data="(n) => {
                formData[name] = n
                onChange(formData[name])
              }"
            />

            <template v-if="fieldType === 'telephone'">
              <FormsGeneratorTelephone
                :id="`${uniqId}_${i}`"
                :data="{
                  id: `${uniqId}_${i}`,
                  field,
                  formData,
                  name,
                  disabled,
                  elementClasses,
                  errorMessage,
                  optional: attrs.rules?.spec?.optional
                }"
                @return-data="(n) => {
                  formData[name] = n
                  onChange(formData[name])
                }"
                @valid-data="(n) => {
                  customErrors[name] = !n ? $t('telephoneInvalid') : false
                  invalidField(customErrors[name])
                }"
              />
            </template>

            <FormsGeneratorQuantity
              v-if="fieldType === 'quantity'"
              :key="formData[name]"
              :data="{
                id: `${uniqId}_${i}`,
                field,
                formData,
                name,
                maska,
                disabled,
                placeholder,
                min,
                max,
                errorMessage,
                onChange,
                onInput
              }"
              @return-data="(n) => {
                formData[name] = n
                onChange(formData[name])
              }"
            />      

            <FormsGeneratorDefaultSelect
              v-if="fieldType === 'select'"
              :data="{
                id: `${uniqId}_${i}`,
                formData,
                fieldType,
                name,
                placeholder,
                options,
                disableSelectOption,
                disabledSelectOptions,
                filter: additionalOptions.filter,
                disabled,
                elementClasses,
                errorMessage
              }"
              @return-data="(n) => {
                formData[name] = n
                onChange(formData[name])
              }"
            />

            <ClientOnly>
              <FormsGeneratorAddressSelect
                v-if="fieldType === 'address'"
                :data="{
                  id: `${uniqId}_${i}`,
                  formData,
                  fieldType,
                  name,
                  secondName,
                  placeholder,
                  disabledSelectOptions,
                  filter: additionalOptions.filter,
                  selectDefault: additionalOptions.selectDefault,
                  disabled,
                  elementClasses,
                  errorMessage
                }"
                @return-data="(n) => {
                  formData[name] = n
                  onChange(formData[name])
                }"
              />
            </ClientOnly>

            <label
              v-if="fieldType === 'checkbox'"
              class="flex cursor-pointer"
              :class="{'isCheckbox': fieldType === 'checkbox'}"
            >
              <ToggleSwitch
                v-if="variant === 'toggleSwitch'"
                :id="`${uniqId}_${i}`"
                v-model="formData[name]"
                :disabled="disabled"
                :name="name"
                :true-value="1"
                :false-value="0"
                :class="[errorMessage ? 'invalid' : 'valid', elementClasses ]"
                @change="onChange(formData[name])"
              />

              <Checkbox
                v-else
                :id="`${uniqId}_${i}`"
                v-model="formData[name]"
                v-bind="field"
                :binary="true"
                :disabled="disabled"
                :name="name"
                :true-value="1"
                :false-value="0"
                :class="[errorMessage ? 'invalid' : 'valid', elementClasses ]"
                @change="onChange(toBoolean(formData[name]))"
              />

              <span class="pl-2 leading-normal">
                <span
                  v-if="label"
                >
                  <span>{{ label }}</span>

                  <span
                    v-if="subLabel"
                    class="subLabel"
                  > {{ subLabel }}</span>

                  <HelpersTooltipHelpers
                    v-if="tooltip || helpersData"
                    :data="{
                      parentClasses: 'px-2 ml-0 inline-block',
                      tooltip,
                      helpersData
                    }"
                  />
                </span>
                <p
                  v-if="placeholder"
                  class="small regular grey-text text-lighten-1 mt-0"
                >{{ placeholder }}</p>
              </span>
            </label>

            <template v-if="fieldType === 'radio'">
              <fieldset>
                <legend
                  v-if="label"
                  class="active font-normal"
                  :for="`${uniqId}_${i}`"
                >
                  {{ label }}
                  <span
                    v-if="subLabel"
                    class="subLabel"
                  > {{ subLabel }}</span>

                  <HelpersTooltipHelpers
                    v-if="tooltip || helpersData"
                    :data="{
                      parentClasses: 'px-2 ml-0 inline-block',
                      tooltip,
                      helpersData
                    }"
                  />
                </legend>

                <FormsGeneratorRadio
                  :data="{
                    id: `${uniqId}_${i}`,
                    formData,
                    name,
                    type,
                    field,
                    value,
                    options,
                    label,
                    additionalOptions,
                    placeholder,
                    errorMessage
                  }"
                  @return-data="(n) => {
                    formData[name] = n
                    onChange(formData[name])
                  }"
                />
              </fieldset>
            </template>

            <template v-if="fieldType === 'chip'">
              <label
                v-if="label"
                class="active"
              >
                {{ label }}
                <span
                  v-if="subLabel"
                  class="subLabel"
                > {{ subLabel }}</span>

                <HelpersTooltipHelpers
                  v-if="tooltip || helpersData"
                  :data="{
                    parentClasses: 'px-2 ml-0 inline-block',
                    tooltip,
                    helpersData
                  }"
                />
              </label>

              <FormsGeneratorDefaultChip
                :data="{
                  id: `${uniqId}_${i}`,
                  formData,
                  fieldType,
                  name,
                  placeholder,
                  disabled,
                  errorMessage,
                  additionalOptions
                }"
                @return-data="(n) => {
                  formData[name] = n
                  onChange(formData[name])
                }"
              />
            </template>

            <FormsGeneratorProjects
              v-if="fieldType === 'projects'"
              :id="props.id"
              :data="{
                id: `${uniqId}_${i}`,
                formData,
                name,
                type,
                disabled,
                secondName,
                additionalFields,
                additionalOptions,
                availableProjects,
                disclaimer,
                placeholder,
                errorMessage
              }"
              @return-data="(n) => {
                if (n[name]) {
                  formData[name] = n[name]
                  onChange(formData[name])
                }

                if (n[secondName]) {
                  formData[secondName] = n[secondName]
                  onChange(formData[secondName])
                }

                if (additionalFields) {
                  for (const item of additionalFields) {
                    formData[item.name] = n[item.name]
                    onChange(formData[item.name])
                  }
                }
              }"
              @is-pending="(n) => {
                emit('isPending', n)
              }"
            />

            <template v-if="warning && warning.type && warning.message">
              <span
                v-if="warning.type === 'message'"
                class="infoMsg warning"
              >{{ warning.message }}</span>

              <span
                v-else-if="warning.type === 'error'"
                class="infoMsg warning"
              >{{ warning.message }}</span>
            </template>

            <div
              v-if="disclaimer && !errorMessage && fieldType !== 'attachFile' && fieldType !== 'uploader'"
              class="text-[11px] font-light pt-3 leading-[150%]"
              v-html="disclaimer"
            >
            </div>

            <div
              v-if="disclaimerWithTooltip && !errorMessage && fieldType !== 'attachFile' && fieldType !== 'uploader'"
              class="text-[11px] font-light pt-3 leading-[150%]"
            >
              <span
                v-if="disclaimerWithTooltip.before"
                v-html="disclaimerWithTooltip.before"
              ></span>

              <HelpersTooltipHelpers
                v-if="disclaimerWithTooltip.linkName"
                :data="{
                  parentClasses: 'inline-flex border-b border-black border-bottom border-dotted cursor-help',
                  tooltip: disclaimerWithTooltip.tooltip,
                  content: disclaimerWithTooltip.linkName
                }"
              />

              <span
                v-if="disclaimerWithTooltip.after"
                v-html="disclaimerWithTooltip.after"
              ></span>
            </div>

            <template v-if="fieldType === 'privacyDisclaimer'">
              <label
                class="flex cursor-pointer"
              >
                <Checkbox
                  :id="`${uniqId}_${i}`"
                  v-bind="field"
                  v-model="formData[name]"
                  :binary="true"
                  :disabled="disabled"
                  :class="[errorMessage ? 'invalid' : 'valid', elementClasses, { 'hidden': hiddenCheckbox } ]"
                  @blur="onChange(formData[name])"
                />

                <span class="pl-2 leading-normal">
                  <span v-if="!hiddenCheckbox">
                    <p class="small description">
                      {{ $t('privacyPolicyDescr') }}
                      <NuxtLink
                        class="clear-link"
                        :to="confNavigation.system.find(n => n.id === 'privacy').link"
                        :title="$t('privacyPolicy')"
                      >
                        {{ $t('privacyPolicy') }}
                      </NuxtLink>.
                    </p>
                  </span>

                  <p
                    v-else
                    class="small description"
                  >
                    {{ $t('privacyPolicyDescr') }}
                    <NuxtLink
                      class="clear-link"
                      target="_black"
                      :to="confNavigation.system.find(n => n.id === 'privacy').link"
                      :title="$t('privacyPolicy')"
                    >
                      {{ $t('privacyPolicy') }}
                    </NuxtLink>.
                  </p>
                </span>
              </label>
            </template>

            <template v-if="fieldType === 'uploader'">
              <FormsGeneratorUploader
                :key="formData[fileFieldName]"
                :uuid="uuidv4()"
                :member-token="props.memberToken"
                :label="label"
                :name="name"
                :file-field-name="fileFieldName"
                :attach-file="formData[fileFieldName]"
                :element-classes="elementClasses"
                :additional-options="additionalOptions"
                :disclaimer="disclaimer"
                :placeholder="placeholder"
                :accept="accept"
                :disabled="disabled"
                :max="max"
                @return-data="(data) => {
                  onChange(data)
                  emit('returnData', uploadFile(data, fileFieldName))
                }"
                @submit-form="(data) => {
                  emit('submitForm', uploadFile(data, fileFieldName))
                }"
                @is-pending="(data) => {
                  emit('isPending', data)
                }"
              />
            </template>

            <template v-if="fieldType === 'attachFile'">
              <label
                v-if="label"

                class="active"
              >
                {{ label }}

                <span
                  v-if="subLabel"
                  class="subLabel"
                > {{ subLabel }}</span>

                <HelpersTooltipHelpers
                  v-if="tooltip || helpersData"
                  :data="{
                    parentClasses: 'px-2 ml-0 inline-block',
                    tooltip,
                    helpersData
                  }"
                />
              </label>

              <FormsUploadFile
                :attach-file="formData[fileFieldName]"
                :element-classes="elementClasses"
                :options="options"
                :disclaimer="disclaimer"
                :placeholder="placeholder"
                :accept="accept"
                :disabled="disabled"
                :max="max"
                @file="async (data) => {
                  emit('returnData', await uploadFile(data, fileFieldName))
                }"
                @return-data="(data) => {
                  onChange(data)
                  emit('submitForm', data)
                }"
              />
            </template>

            <template
              v-if="type === 'subFields'
                && (fieldType === 'subFieldsDrawer' || fieldType === 'customizationNotes' || fieldType === 'personalizationQuestions'
                  || fieldType === 'cardMessage' || fieldType === 'greetingVideo' || fieldType === 'forwardEmails' || fieldType === 'projectsList')"
            >
              <FormsGeneratorSubFields
                :data="{
                  label,
                  subLabel,
                  disclaimer,
                  altLabel,
                  name,
                  invalid: errors[name] || invalid,
                  disabled,
                  tooltip,
                  helpersData,
                  isGroup,
                  additionalFields,
                  additionalOptions,
                  pending,
                  linkTo,
                  linkType,
                  options,
                  error
                }"
                :form-data="props.data"
                :fields="groupFields"
                :field-type="fieldType"
                :callback="callback"
                @return-data="async (data) => {
                  const newData = JSON.parse(JSON.stringify(formData))
              
                  for (const i in data) {
                    newData[i] = data[i]
                  }

                  formData = newData

                  emit('isValid', true)
                  emit('invalidData', false)

                  onChange(newData)

                  emit('returnData', newData)
                }"
              />
            </template>
          </Field>

          <i
            v-if="type === 'password'"
            class="icon absolute"
            :class="[ 
              showPassword[name] ? 'icon-b-eye' : 'icon-eye',
              { 'right-4 bottom-4': !props.options?.size },
              { 'right-4 bottom-4 md:bottom-5 xl:bottom-6': props.options?.size === 'large' }
            ]"
            @click="showPassword[name] = !showPassword[name]"
          ></i>
        </div>

        <span
          v-if="customErrors[name]" 
          class="helper-text red-text"
        >
          {{ customErrors[name] }}
        </span>

        <ErrorMessage
          v-else-if="fieldType !== 'emailAddresses' && fieldType !== 'fulfillmentAddresses' && fieldType !== 'radioBlocks' && fieldType !== 'subFields'"
          :name="name"
          class="helper-text red-text"
        />

        <label
          v-if="(label || tooltip || helpersData || subLabel) && type !== 'checkbox' && type !== 'radio' && fieldType !== 'chip' && type !== 'subFields' && fieldType !== 'heading' && fieldType !== 'image' && fieldType !== 'helpers' && fieldType !== 'button' && fieldType !== 'attachFile' && fieldType !== 'uploader'"
          :for="`${uniqId}_${i}`"
          class="active"
          :class="[
            {'pl-14': additionalOptions?.stepper}
          ]"
        >{{ label }}

          <span
            v-if="subLabel"
            class="subLabel"
          > {{ subLabel }}</span>

          <HelpersTooltipHelpers
            v-if="tooltip || helpersData"
            :data="{
              parentClasses: 'px-2 ml-0 inline-block',
              tooltip,
              helpersData
            }"
          />
        </label>

        <template v-if="fieldType === 'descriptionBlock'">
          <div
            class="description-text"
            :class="elementClasses"
          >
            <p
              v-if="placeholder"
              class="small grey-text text-darken-1 mb-0"
              v-html="placeholder"
            ></p>
          </div>
        </template>

        <template v-if="fieldType === 'messageBlock'">
          <Message
            :severity="additionalOptions?.severity ? additionalOptions.severity : 'info'"
            :size="additionalOptions?.size ? additionalOptions.size : null"
            :pt-options="{
              variant: additionalOptions?.variant
            }"
            :class="elementClasses"
          >
            <span v-html="placeholder"></span>
          </Message>
        </template>

        <template v-if="fieldType === 'button'">
          <div class="btn-horder">
            <button
              class="btn waves-effect waves-light"
              role="button"
              :type="type"
              :disabled="disabled"
              :class="elementClasses"
              @click="() => {
                emit('isValid', meta.valid)
                onChange($event)
              }"
            >
              <span
                v-html="label"
              ></span>

              <span
                v-if="subLabel"
                class="subLabel"
              > {{ subLabel }}</span>
            </button>

            <template v-if="externalReviews">
              <HelpersReviews
                v-if="externalReviews.enable"
                :external-reviews="externalReviews.items"
              />
            </template>
          </div>
        </template>

        <template v-if="fieldType === 'link'">
          <Button
            :label="label"
            size="small"
            link
            severity="secondary"
            :pt-options="{
              variant: 'extra'
            }"
            as="a"
            :to="linkTo"
            target="_blank"
          />
        </template>
      </div>
    </template>
  </Form>
</template>

<script setup>
/**
 * HELPERS
 *
 *   // Reset form
 *   document.querySelector('.checkout').querySelectorAll('.js-resetForm').forEach((item) => {
 *     item.click()
 *   })
 *   or
 *
 *   const resetForm = ref({})
 *   <FormsGenerator
 *      v-for="schemaItem, key in schema"
 *      ...
 *      @reset-form="(n) => resetForm[key] = n"
 *   />
 *   resetForm.value[<name>]()
 *
 *
 *   // We start forced validation to highlight the fields that are not filled
 *   document.querySelector('.checkout').querySelectorAll('.js-startValidateForm').forEach((item) => {
 *     item.click()
 *   })
 */
import { Form, Field, ErrorMessage } from 'vee-validate'
import { v4 as uuidv4 } from 'uuid'

const uniqId = useId()
const { confNavigation } = useConfig()
const { drawerOptions } = usePopups()

const startValidateForm = ref(false)
const form = ref(null)
const showPassword = ref({})
const submitFormRef = ref(null)

/*
* Custom Errors
*/
const customErrors = ref({})

const hasCustomErrors = computed(() => {
  return Object.values(customErrors.value).some(value => value === true)
})

/**
* Props
*/
const props = defineProps({
  id: {
    type: [String],
    default: null
  },
  memberToken: {
    type: [String, Boolean],
    default: null
  },
  fields: {
    type: [Object],
    default: null
  },
  data: {
    type: [Object],
    default: null
  },
  options: {
    type: [Object],
    default: null
  }
})

/**
* Emits
*/
const emit = defineEmits(['returnData', 'isValid', 'invalidData', 'resetForm', 'submitForm', 'isPending'])

/**
* Form Data
*/
const formData = ref({})
const autocompleteForm = () => {
  for (const field of props.fields) {
    if (field.isField !== false) {
      if (!formData.value[field.name]) {
        formData.value[field.name] = field.type === 'checkbox' && field.fieldType !== 'attachFile'
          ? toBoolean(props.data[field.name])
          : props.data[field.name]

        if (field.secondName) {
          formData.value[field.secondName] = field.type === 'checkbox' && field.fieldType !== 'attachFile'
            ? toBoolean(props.data[field.secondName])
            : props.data[field.secondName]
        }
      } else {
        formData.value[field.name] = ''

        if (field.secondName) {
          formData.value[field.secondName] = ''
        }
      }
    }
  }

  if (props.data.hasOwnProperty('attachFile')) {
    formData.value.attachFile = props.data.attachFile
  }

  if (props.data.hasOwnProperty('artworkFile')) {
    formData.value.artworkFile = props.data.artworkFile
  }
}
autocompleteForm()

/**
* Format Data
*/
const propsData = computed({
  get() {
    return props.data
  }
})

watch(propsData, (newData) => {
  if (newData) {
    for (const field of props.fields) {
      if (field.isField !== false) {
        formData.value[field.name] = field.type === 'checkbox' && field.fieldType !== 'attachFile' && newData[field.name]
          ? toBoolean(newData[field.name])
          : newData[field.name]
      }

      if (field.isField !== false) {
        formData.value[field.secondName] = field.type === 'checkbox' && field.fieldType !== 'attachFile' && newData[field.secondName]
          ? toBoolean(newData[field.secondName])
          : newData[field.secondName]
      }
    }
  }
}, { deep: true })

/**
* Reset Form
*/
watch(form, (newForm) => {
  if (newForm) {
    emit('resetForm', newForm.resetForm)
  }
}, { deep: true })

/**
* Return FormData
*/
watch(formData, (newA) => {
  emit('returnData', newA)
}, { deep: true })

/**
* After Upload File
*/
const uploadFile = async (data, name) => {
  const newData = JSON.parse(JSON.stringify(formData.value))

  if (data.pending) {
    newData[name] = 'pending'
  } else {
    const dataFile = await data
    newData[name] = dataFile.data

    if (dataFile?.data?.url) {
      newData[name] = dataFile.data.url
    } else if (dataFile?.data) {
      newData[name] = dataFile.data
    } else if (dataFile[name]) {
      newData[name] = dataFile[name]
    } else {
      newData[name] = ''
    }

    return newData
  }
}
</script>

<style lang="scss" scoped>
.input-field {
  &.isQuantity {
    & > * {
      max-width: 160px;
    }
  }

  &.required.invalid {
    border-color: color("red", "base");
    &:deep(.selectProjects__button) {
      border-color: color("red", "base-1")!important;
    }
  }

  .subLabel {
    font-weight: 300;
  }
}
</style>
